import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import MessagesTemplateListContainer from '../../MessagesTemplate/MessagesTemplateListContainer';
import CommunityMessageListItemContainer from './CommunityMessageListItemContainer';

import * as commonSelectors from '../../Shared/selectors';
import * as communitySelectors from '../selectors';

const CommunityMessagesSellerListContainer = (props) => {
  const { baseUrl } = props;

  return (
    <MessagesTemplateListContainer
      {...props}
      messageUrl={`${baseUrl}`}
      MessageTemplateListItem={CommunityMessageListItemContainer}
    />
  );
};

CommunityMessagesSellerListContainer.defaultProps = {
  nextMessages: null,
  chats: [],
  currentChatId: null,
};

CommunityMessagesSellerListContainer.propTypes = {
  nextMessages: PropTypes.shape({
    limit: PropTypes.number,
    offset: PropTypes.number,
  }),
  getThreadsList: PropTypes.func.isRequired,
  chats: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool.isRequired,
  currentChatId: PropTypes.number,
  baseUrl: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { common } = state;
  const chats = communitySelectors.getCommunityMessagesList(state);
  const currentChatId = Number(ownProps?.match?.params?.id ?? null);
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);
  const nextMessages = state?.community?.communityChats?.next || null;
  const isLoading = !!common?.loading?.length;
  return {
    currentChatId,
    chats,
    isMobileScreen,
    nextMessages,
    isLoading,
  };
};

export default connect(
  mapStateToProps,
  null,
)(CommunityMessagesSellerListContainer);
